import Legal from '@/components/legal';

export default Legal;
